import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { ProductConfiguratorService } from './shared';
import { AuthenticationService, UtilityService, ValidationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { CartService } from './../cart/cart.service';
import {
  ProductModel, CartModel, PriceModel, ResponseCartModel, RequestCartModel, RequestLineItemModel, LineItemModel, SkusModel, PriceInfoModel,
  TotalPriceInfoModel
} from './../../models';
import { HeaderService } from './../header/header.service';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var logoutCurrentUser: any;
// declare var checkCart: any;

@Component({
  selector: 'app-product-configurator',
  providers: [ValidationService, ProductConfiguratorService, CartService,
    AdobeAnalyticsService], // utilityService is provided in app component already
  templateUrl: './product-configurator.component.html',
  styleUrls: ['./product-configurator.component.scss']
})
export class ProductConfiguratorComponent implements OnInit, OnDestroy {

  productDetail: ProductModel;
  tmpPricingObj: any = [];
  totPricingObj: any = [];
  selectedindex;
  serviceconfigurationform: FormGroup;
  initialQty: any = 1;
  tmpQty: any = 1;
  cart: CartModel;
  pricePointLineItem: LineItemModel;
  cartItemDisplayName = '';
  requestCart: RequestCartModel;
  requestLineItem: RequestLineItemModel;
  responseCart: ResponseCartModel;
  id: string;
  updateCart = true;
  requestPriceInfoObj = {
    dcmCodes: [],
    quantity: 0
  };
  maxQty = 1;
  setError: boolean;
  ErrorMessage: string;
  setInfo: boolean;
  infoHeader: string;
  infoMessage: string;
  volumeContent: any = {};
  priceErr = false;
  formErrors = {
    'qty': ''
  };
  validationMessages = {
    'qty': {
      'required': 'No.of Licenses is required.',
      'pattern': 'Please enter a valid numeric value from 1 to ' + this.maxQty + '.',
      'limitErr': 'No more licenses are available for this purchase.'
    }
  };
  firstRun = true;
  disableRadio = false;
  skuId: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private productConfiguratorService: ProductConfiguratorService,
    private utilityService: UtilityService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private cartService: CartService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private http: HttpClient, private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService,
    private headerService: HeaderService) {
  }

  ngOnInit() {
    this.headerService.setCondensedFooterStatus(false);
    this.headerService.condensedHeader('productConfigurator');
    this.breadCrumbService.setCurrentBreadCrumb(undefined);
    if (this.authenticationService.getUser() === null) {
      // this.router.navigate(['login']);
      window.location.href = '/businessconsole/login';
    }
    this.id = this.route.snapshot.params['id'];
    this.productDetail = new ProductModel();
    this.productDetail = JSON.parse(sessionStorage.getItem('productConfig-' + this.id));
    if (this.productDetail.skus && this.productDetail.skus.length > 1) {
      this.disableRadio = false;
    } else {
      this.disableRadio = true;
    }

    if (this.productDetail === null) {
      this.router.navigate(['/home']);
      return;
    }

    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    document.body.classList.add('productconfigurator-page');
    const url = this.router.routerState.snapshot.url;
    const updatedUrl = url.substring(0, url.lastIndexOf('/'));
    document.title = this.utilityService.getPageTitleConfig()[updatedUrl];

    this.initialQty = this.productDetail.quantity;
    this.cart = JSON.parse(sessionStorage.getItem('cart'));


    this.productDetail.skus.sort((sku1, sku2): number => {
      return (parseInt(sku1.basicPrice, 10) - parseInt(sku2.basicPrice, 10));
    });
    this.productDetail.skus.sort((sku1, sku2): number => {
      return (sku2.selected - sku1.selected);
    });

    if (this.cart) {
      this.productDetail.skus.sort((sku1, sku2): number => {
        return (parseInt(sku1.basicPrice, 10) - parseInt(sku2.basicPrice, 10));
      });
      this.productDetail.skus.sort((sku1, sku2): number => {
        return (sku2.selected - sku1.selected);
      });
      if (!!this.productDetail.skus && this.productDetail.skus !== null && this.productDetail.skus !== undefined) {
        this.productDetail.skus.forEach((productObj, index) => {
          if (productObj.selected === 1) {
            this.selectedindex = index;
          }
        });
      }
    } else {
      this.selectedindex = 0;
    }

    if (!!this.cart && !!this.cart.lineItems) {
      for (const item of this.cart.lineItems) {
        if (item.productId === this.id) {
          if (!this.productDetail.skus[0].isSelectedProduct) {
            this.setInfo = true;
            if (item.sku.id === this.productDetail.skus[0].id) {
              this.initialQty = item.quantity;
              this.infoHeader = item.sku.skuType + ' ' + this.productDetail.displayName + '  is already in your cart.';
              this.infoMessage = 'You can not have two instances of this product in your cart but you can add more licenses to it.';
            } else {
              this.infoHeader = item.sku.skuType + ' ' + this.productDetail.displayName + '  is already in your cart.';
              // tslint:disable-next-line:max-line-length
              this.infoMessage = 'You are limited to a single ' + item.sku.skuType + ' package. If you select another package and click on Add to cart, the selected package will replace the one that\'s in your cart. ';
            }
          }
        }
      }
    } else {
      this.setInfo = false;
    }
    this.priceUpdate(this.selectedindex);
    this.productConfiguratorService.createPageLoadProperties(
      this.productDetail.skus,
      this.router.routerState.snapshot.url,
      'Product Configurator');
  }

  buildForm(): void { // creating formcontrol as a group that is used as formControlName in html

    this.serviceconfigurationform = this.formBuilder.group({
      qty: [this.initialQty,
      [Validators.required,
      Validators.pattern('^(0|[1-9][0-9]*)$')]]
    }, { validator: this.productConfiguratorService.checkQty('qty', this.maxQty) });

    this.validationService.validate(
      this.serviceconfigurationform,
      this.formErrors,
      this.validationMessages);

  }

  priceUpdate(selectedIndex) {
    this.pageloaderService.setPageLoaderStatus(false);
    if (this.serviceconfigurationform && this.serviceconfigurationform.value && this.serviceconfigurationform.value.qty) {
      this.tmpQty = this.serviceconfigurationform.value.qty;
    } else {
      this.tmpQty = this.initialQty;
    }

    if (!!this.productDetail.skus && this.productDetail.skus !== null && this.productDetail.skus !== undefined) {
      this.requestPriceInfoObj.dcmCodes = [];
      this.productDetail.skus.forEach((prodobj, pIndex) => {
        this.requestPriceInfoObj.dcmCodes.push(prodobj.id);
      });
    }
    if (this.serviceconfigurationform && this.serviceconfigurationform.value && this.serviceconfigurationform.value.qty) {
      this.requestPriceInfoObj.quantity = this.serviceconfigurationform.value.qty;
    } else {
      this.requestPriceInfoObj.quantity = this.initialQty;
    }
    this.productConfiguratorService.getPricingInfo(
      this.utilityService.getEnvConfig().pricingupdate + this.productDetail.id, this.requestPriceInfoObj
    ).subscribe(pricingrespobj => {
      this.setError = false;
      this.priceErr = false;
      this.ErrorMessage = '';
      this.tmpPricingObj = pricingrespobj;
      if (!!this.tmpPricingObj && this.tmpPricingObj !== null && this.tmpPricingObj !== undefined) {
        this.tmpPricingObj.forEach((skuobj, sIndex) => {
          if (this.firstRun) {
            skuobj.monthlyRecurringFee.price.forEach((price, inIndex) => {
              if (price.maxQty > this.maxQty) {
                this.maxQty = price.maxQty;
              }
            });
            this.validationMessages.qty.pattern = 'Please enter a valid numeric value from 1 to ' + this.maxQty + '.';
              this.buildForm();
            this.firstRun = false;
          }
          skuobj.totalOneTimeFee = 0;
          if (!!skuobj.oneTimeFee && skuobj.oneTimeFee !== null && skuobj.oneTimeFee !== undefined) {
            skuobj.oneTimeFee.forEach((otf, oIndex) => {
              skuobj.totalOneTimeFee += otf.price[0].amount;
            });
          }
          if (!!this.productDetail.skus && this.productDetail.skus !== null && this.productDetail.skus !== undefined) {
            this.productDetail.skus.forEach((prodobj, pIndex) => {
              if (skuobj.dcmCode === prodobj.id) {
                this.productDetail.skus[pIndex].priceInfo = skuobj;
              }
            });
          }
        });
      }
      this.totalCalculation(selectedIndex);
      this.pageloaderService.setPageLoaderStatus(true);
    }, error => {
      this.setErrorMessage(error);
    });
  }

  totalCalculation(index) {
    this.totPricingObj = {};
    this.totPricingObj.oneTime = this.productDetail.skus[index].priceInfo['totalOneTimeFee'];
    this.totPricingObj.perMonth = this.productDetail.skus[index].priceInfo['monthlyRecurringFee']['totalPrice'];
    this.totPricingObj.unitPrice = this.productDetail.skus[index].priceInfo['monthlyRecurringFee']['unitPrice'];
    this.totPricingObj.singleQuantityCheck = this.productDetail.skus[index].priceInfo['monthlyRecurringFee']['price'][index]['maxQty'];
    this.volumeContent = this.productDetail.skus[index].priceInfo['monthlyRecurringFee'];

  }

  radioselection(rowIndex, event) {
    event.preventDefault();
    if (!!this.productDetail.skus && this.productDetail.skus !== null && this.productDetail.skus !== undefined) {
      this.productDetail.skus.forEach((productObj) => {
        productObj.selected = (productObj.id === this.productDetail.skus[rowIndex].id) ? 1 : 0;
        productObj.isSelectedProduct = (productObj.id === this.productDetail.skus[rowIndex].id) ? true : false;
      });
    }
    this.selectedindex = rowIndex;
    this.totalCalculation(rowIndex);
  }

  updateQty() {
    this.priceUpdate(this.selectedindex);
  }

  addToCart(event) {
    this.authenticationService.setLoginSuccessUrl('cart');
    this.cart = JSON.parse(sessionStorage.getItem('cart'));
    const sku = this.productDetail.skus[this.selectedindex];
    this.skuId = sku.id;
    const productDetail = this.productDetail;
    const lineItem: LineItemModel = new LineItemModel();
    const priceInfo: PriceInfoModel = new PriceInfoModel();
    lineItem.sku = sku;
    lineItem.quantity = this.tmpQty;
    lineItem.productId = productDetail.id;
    lineItem.displayName = sku.displayName;
    // lineItem.tncUrl = sku.tncUrl;
    /**
     *  Getting tncUrl from cart Session
     */
    lineItem.tncUrl = this.productDetail.tncUrl;

    lineItem.skuId = sku.id;
    lineItem.maxQty = this.maxQty;
    lineItem.childDcmCodes = [];
    for (const childSku of this.productDetail.skus) {
      if (childSku.id !== sku.id) {
        lineItem.childDcmCodes.push(childSku.id);
      }
    }

    lineItem.priceInfo = priceInfo;
    lineItem.priceInfo.oneTimeFee = sku.priceInfo.oneTimeFee;
    lineItem.priceInfo.monthlyRecurringFee = sku.priceInfo.monthlyRecurringFee;
    if (this.cart && this.cart != null && this.cart.lineItems && this.cart.lineItems.length > 0) {
      if (!this.cartService.checkProductAlreadyPresent(this.cart.lineItems, lineItem)) {
        this.cart.lineItems.push(lineItem);
        if (lineItem.priceInfo.oneTimeFee === undefined || lineItem.priceInfo.oneTimeFee === null) {
          lineItem.priceInfo.oneTimeFee = new PriceModel();
          lineItem.priceInfo.oneTimeFee.amount = 0;
        }
        this.cart.priceInfo.oneTimeFee.amount = this.cart.priceInfo.oneTimeFee.amount + lineItem.priceInfo.oneTimeFee.amount;
        this.cart.priceInfo.monthlyRecurringFee.amount = this.cart.priceInfo.monthlyRecurringFee.amount +
          lineItem.priceInfo.monthlyRecurringFee.amount;
        this.setCartToSession();
      } else {
        this.pricePointLineItem = lineItem;
        this.cart.lineItems = this.cartService.updateCartItemwithNewSku(this.cart.lineItems, this.pricePointLineItem);
        this.setCartToSession();
      }
    } else {
      this.cart = new CartModel();
      this.cart.priceInfo = new TotalPriceInfoModel();
      this.cart.lineItems = new Array<LineItemModel>();
      this.cart.lineItems.push(lineItem);
      const onetimeFee: PriceModel = new PriceModel();
      const monthlyRecurringFee: PriceModel = new PriceModel();
      if (lineItem.priceInfo.oneTimeFee) {
        onetimeFee.amount = lineItem.priceInfo.oneTimeFee.amount;
      } else {
        onetimeFee.amount = 0;
      }
      monthlyRecurringFee.amount = lineItem.priceInfo.monthlyRecurringFee.amount;
      this.cart.priceInfo.oneTimeFee = onetimeFee;
      this.cart.priceInfo.monthlyRecurringFee = monthlyRecurringFee;
      this.setCartToSession();
    }
  }

  setCartToSession() {
    sessionStorage.setItem('cart', JSON.stringify(this.cart));
    sessionStorage.setItem('productConfig-' + this.id, JSON.stringify(this.productDetail));
    const product = this.cart.lineItems.find((data) => (data.skuId === this.skuId));
    this.productConfiguratorService.createAdobeEventProperties(product, 'SUCCESS', 'formSubmit', 'submit');
    this.productConfiguratorService.createAdobeEventProperties(product, 'SUCCESS', 'formResponse', 'submit');
    // this.headerService.checkCart();
    if (this.authenticationService.getUser() === null) {
      // this.router.navigate(['login']);
      window.location.href = '/businessconsole/login';
    } else {
      this.router.navigate(['cart']);
    }
  }

  handleError(error) {
    throw error;
  }

  gotoDetailPage(productId) {
    this.router.navigate(['/browse/details/' + productId]);
  }

  setErrorMessage(error) {
    this.pageloaderService.setPageLoaderStatus(true);
    if (error.status === 401) {
      this.setError = true;
      this.ErrorMessage = 'Session expired, Please login again.';
      logoutCurrentUser(true);
    } else if (error.status === 400) {
      this.setError = true;
      this.priceErr = true;
      if (error.error[0]) {
        this.ErrorMessage = JSON.stringify(error.error[0]);
      } else if (error.error) {
        this.ErrorMessage = error.error;
      } else {
        this.ErrorMessage = 'Can not add more than max-qty';
      }
    } else {
      this.setError = true;
      this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
    }
    this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse',
      error.status === 400 ? 'Failure_BusinessRule' : undefined);
    this.utilityService.loadFocusOnTop();
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
